<div class="listing-controls">
  <app-listing-filter
    [options]="colDefs"
    (sortOptionSelectedEventEmitter)="sortOptionSelected($event)"
    (sortDirectionSelectedEventEmitter)="toggleAscDesc($event)"
  >
  </app-listing-filter>
  <app-listing-search (searchFilterEventEmitted)="searchNotifications($event)"></app-listing-search>
</div>
<table class="notification-table">
  <thead>
    <tr>
      <th>
        Date
      </th>
      <th>
        Patient
      </th>
      <th>
        Type
      </th>
      <th>
        Care Rep
      </th>
      <th>
        Status
      </th>
    </tr>
  </thead>
  <tbody *ngIf="hasVisibleNotifications; else noNotifications">
    <tr *ngFor="let notification of notificationsFiltered; trackBy: trackByNotification" class="active">
      <td>
        {{ notification.notificationCreatedTime | date: 'MM/dd/yy':'UTC' }}
      </td>
      <td class="has-link" [routerLink]="'/notifications/' + notification.notificationId">
        {{ notification.notificationPatientFirstName }}, {{ notification.notificationPatientLastName }}
      </td>
      <td>
        <i class="notification-icon" class="{{ notification.notificationTypeLabel }}"></i>
        <span>{{ notification.notificationTypeLabel }} </span>
      </td>
      <td>
        {{ notification.notificationCreatedByUserFirstName }}
        {{ notification.notificationCreatedByUserLastName }}
      </td>
      <td>
        <span class="status-badge" [ngClass]="'status-' + (getDisplayStatus(notification) | lowercase)">
          {{ getDisplayStatus(notification) }}
          <span class="reply-count" *ngIf="getReplyCount(notification) > 0"> ({{ getReplyCount(notification) }}) </span>
        </span>
        <select
          *ngIf="hasEditableStatuses()"
          class="status-select"
          [value]="getStatusSelectValue(notification)"
          (change)="onStatusSelectChange(notification, $event.target.value)"
        >
          <option value="" disabled>Select status</option>
          <option *ngFor="let option of statusOptions" [value]="option.id">
            {{ option.label }}
          </option>
        </select>
      </td>
    </tr>
  </tbody>
</table>
<jw-pagination *ngIf="hasVisibleNotifications" [items]="notificationsFiltered" (changePage)="onChangePage($event)">
</jw-pagination>

<ng-template #noNotifications>
  <table class="notification-table empty-notification-table" *ngIf="hasLoadedNotifications">
    <tbody>
      <tr class="empty-state-row">
        <td class="empty-state-cell" colspan="5">
          {{ emptyStateMessage }}
        </td>
      </tr>
    </tbody>
  </table>
</ng-template>
